export default __webpack_public_path__ + "static/media/hero.e7ab9f45.jpg";